export const menu_data = [
  {
    id: 1,
    hasDropdown: false,
    title: 'Home',
    link: 'home',
    submenus: [
      { title: 'Home One', link: '/' },
      { title: 'Home Two', link: '/home-2/' },
      { title: 'Home Three', link: '/home-3/' },
    ]
  },
  {
    id: 2,
    title: 'About',
    link: 'about',
  },
  {
    id: 4,
    title: 'Projects',
    link: 'collection',
  },
  {
    id: 5,
    title: 'Road Map',
    link: 'roadmap',
  },
  // {
  //   id: 6,
  //   hasDropdown: true,
  //   title: 'Blog',
  //   link: '/blog',
  //   submenus: [
  //     { title: 'Blog', link: '/blog/' },
  //     { title: 'Blog Details', link: '/blog-details/' },
  //   ]
  // },
]
// menu data 2
export const menu_data_2 = [
  {
    id: 1,
    hasDropdown: true,
    title: 'Home',
    link: 'home',
    submenus: [
      { title: 'Home One', link: '/' },
      { title: 'Home Two', link: '/home-2/' },
      { title: 'Home Three', link: '/home-3/' },
    ]
  },
  {
    id: 2,
    title: 'Choose',
    link: 'choose',
  },
  {
    id: 3,
    title: 'About',
    link: 'about',
  },
  {
    id: 4,
    title: 'Team',
    link: 'team',
  },
  {
    id: 5,
    title: 'Road Map',
    link: 'roadmap',
  },
  {
    id: 6,
    hasDropdown: true,
    title: 'Blog',
    link: '/blog',
    submenus: [
      { title: 'Blog', link: '/blog/' },
      { title: 'Blog Details', link: '/blog-details/' },
    ]
  },
]

// menu data 2
export const menu_data_3 = [
  {
    id: 1,
    hasDropdown: true,
    title: 'Home',
    link: 'home',
    submenus: [
      { title: 'Home One', link: '/' },
      { title: 'Home Two', link: '/home-2/' },
      { title: 'Home Three', link: '/home-3/' },
    ]
  },
  {
    id: 2,
    title: 'Collection',
    link: 'collection',
  },
  {
    id: 3,
    title: 'Choose',
    link: 'choose',
  },
  {
    id: 4,
    title: 'About',
    link: 'about',
  },
  {
    id: 5,
    title: 'Road Map',
    link: 'roadmap',
  },
  {
    id: 6,
    hasDropdown: true,
    title: 'Blog',
    link: '/blog',
    submenus: [
      { title: 'Blog', link: '/blog/' },
      { title: 'Blog Details', link: '/blog-details/' },
    ]
  },
]